import { EappEnum } from './eAppEnum';

// PVQ Dropdown values
export const federalDebtTypes = [
  'Student loan',
  'Home mortgage loan',
  'Over payment of benefits',
  'Other',
];

// PVQ Dropdown values
export const nonTaxDebtActionOptions = [
  'I\'ve increased my withholdings.',
  'I\'m on a payment plan.',
  'My wages are being garnished.',
  'I\'m using a credit counseling service, debt consolidation service, or other similar service to resolve this debt.',
  'I paid this debt.',
  'Other',
  'None',
];

export enum NonPaymentFederalOptionsValues {
  paidInFull = 'paidInFull',
  paymentPlan = 'paymentPlan',
  wagesGarnished = 'wagesGarnished',
  creditCounsel = 'creditCounsel',
  other = 'other',
  none = 'none'
}

// PVQ Dropdown values
export const nonPaymentNonFederalActionsOptions = new EappEnum([
  {
    i18nField: 'paidInFull', key: NonPaymentFederalOptionsValues.paidInFull, value: NonPaymentFederalOptionsValues.paidInFull, text: 'I\'ve paid these taxes in full.'
  },
  {
    i18nField: 'paymentPlan', key: NonPaymentFederalOptionsValues.paymentPlan, value: NonPaymentFederalOptionsValues.paymentPlan, text: 'I\'m on a payment plan.'
  },
  {
    i18nField: 'wagesGarnished', key: NonPaymentFederalOptionsValues.wagesGarnished, value: NonPaymentFederalOptionsValues.wagesGarnished, text: 'My wages are being garnished.'
  },
  {
    i18nField: 'creditCounsel', key: NonPaymentFederalOptionsValues.creditCounsel, value: NonPaymentFederalOptionsValues.creditCounsel, text: 'I\'m using a credit counseling service, debt consolidation service, or other similar service to help resolve my debt.'
  },
  {
    i18nField: 'other', key: NonPaymentFederalOptionsValues.other, value: NonPaymentFederalOptionsValues.other, text: 'Other'
  },
  {
    i18nField: 'none', key: NonPaymentFederalOptionsValues.none, value: NonPaymentFederalOptionsValues.none, text: 'None'
  },
]);

// PVQ Dropdown values
export const taxDebtActionOptions = [
  'I\'m on an IRS short term payment plan (paying in 180 days or less).',
  'I\'m on an IRS long-term payment plan (installment agreement--I pay monthly).',
  'I\'ve increased my withholdings.',
  'The IRS temporarily delayed collecting my taxes due to financial hardship.',
  'My wages are being garnished.',
  'I\'m using a credit counseling service, debt consolidation service or other similar service to resolve my tax debt.',
  'Other',
  'None',
];

// PVQ Dropdown values
export const nonFederalTaxDebtActionOptions = [
  'I\'m on a payment plan.',
  'My wages are being garnished.',
  'I\'m using a credit counseling service, debt consolidation service, or other similar service to help resolve my debt.',
  'Other',
  'None',
];

// PVQ
enum BankruptcyChapterValue {
  Chapter7 = 'Chapter 7 (Liquidation)',
  Chapter11 = 'Chapter 11 (Reorganization)',
  Chapter12 = 'Chapter 12 (Adjustment of Debts of a Family Farmer with Regular Annual Income)',
  Chapter13 = 'Chapter 13 (Adjustment of Debts of an Individual with Regular Annual Income)',
  Chapter15 = 'Chapter 15 (Ancillary and Other Cross-Border Cases)',
}

// PVQ Dropdown values
export const bankruptcyChapterOptions: readonly string[] = [
  BankruptcyChapterValue.Chapter7,
  BankruptcyChapterValue.Chapter11,
  BankruptcyChapterValue.Chapter12,
  BankruptcyChapterValue.Chapter13,
  BankruptcyChapterValue.Chapter15,
];

// PVQ
/** Render the trustee name and address input fields for these values. */
export const BANKRUPTCY_CHAPTER_VALUES_REQUIRING_TRUSTEE: readonly string[] = [
  BankruptcyChapterValue.Chapter12,
  BankruptcyChapterValue.Chapter13,
];

// PVQ Dropdown values
export const evictionEntityTypes = [
  'Company',
  'Government Agency',
  'Individual',
  'Other',
];

// PVQ Dropdown values
export const financialEvictedByOptions = [
  'Company',
  'Government Agency',
  'Individual',
  'Other',
];

// PVQ Dropdown values
export const lienPropertyTypes = [
  'Home (primary residence)',
  'Vehicle',
  'Boat/Plane',
  'Real estate, land, property (other than your primary residence)',
  'Jewelry',
  'All of my property',
  'You (a general lien against you as an individual)',
  'Other personal property',
];

// PVQ Dropdown values
export const lienReasonOptions = [
  'Fulfill a home loan agreement (mortgage lien)',
  'Fulfill an auto loan agreement (auto lien)',
  'Pay a civil judgment (judgment lien)',
  'Pay Federal taxes (tax lien)',
  'Pay state taxes (tax lien)',
  'Pay local taxes (tax lien)',
  'Pay child support',
  'Pay alimony',
  'Pay for medical services after receiving a personal injury award',
  'Pay a credit card company',
  'Pay attorney fees',
  'Pay condominium or homeowner\'s association fees',
  'Pay a mechanic, laborer, or material provider (i.e., contractor\'s lien, mechanic\'s lien, construction lien)',
  'Pay an employee\'s salary',
  'Pay for jewelry',
  'Pay for storage unit',
  'Pay for parking garage',
  'Other',
];

// PVQ Dropdown values
export const foreclosurePropertyTypes = [
  'Primary residence',
  'Secondary residence',
  'Residence that I cosigned for or was guarantor for',
  'Plot of land',
  'Rental property',
  'Commercial property',
  'Other',
];

// PVQ Dropdown values
export const evictionPropertyTypes = [
  'Primary residence',
  'Secondary residence',
  'Residence that I cosigned for or was guarantor for',
  'Plot of land',
  'Rental property',
  'Commercial property',
  'Other',
];

// PVQ Dropdown values
export const lienEntityTypes = [
  'Company',
  'Government Agency',
  'Individual',
  'Other',
];

// PVQ Dropdown values
export const foreclosureEntityTypes = [
  'Company',
  'Government Agency',
  'Individual',
  'Other',
];

// PVQ Dropdown values
export const repossessedPropertyTypes = [
  'Vehicle (automobile, motorcycle, recreational vehicle)',
  'Rent-to-own items (e.g., appliances, electronics, furniture, jewelry, etc.)',
  'Other personal property',
];

// PVQ Dropdown values
export const itemsSeizedTypes = [
  'Wages',
  'Benefits',
  'Other assets',
];

// PVQ Dropdown values
export const taxTypes = [
  'State taxes',
  'Property tax (for example, real estate property)',
  'Personal property tax (for example, for a car or boat)',
  'Other',
];

// PVQ Dropdown values
export const travelCardDisciplinaryOptions = new EappEnum([
  {
    i18nField: 'cardWithdrawn', key: 'cardWithdrawn', value: 'Travel/credit card withdrawn', text: 'Travel/credit card withdrawn'
  },
  {
    i18nField: 'addedTraining', key: 'addedTraining', value: 'Additional training or counseling', text: 'Additional training or counseling'
  },
  {
    i18nField: 'verbal', key: 'verbal', value: 'Verbal reprimand/admonishment/warning', text: 'Verbal reprimand/admonishment/warning'
  },
  {
    i18nField: 'written', key: 'written', value: 'Written reprimand/admonishment/counseling/warning', text: 'Written reprimand/admonishment/counseling/warning'
  },
  {
    i18nField: 'payCut', key: 'payCut', value: 'Temporary Pay Cut', text: 'Temporary Pay Cut'
  },
  {
    i18nField: 'wagesGarnished', key: 'wagesGarnished', value: 'Wage Garnishment', text: 'Wage Garnishment'
  },
  {
    i18nField: 'suspended', key: 'suspended', value: 'Suspended', text: 'Suspended'
  },
  {
    i18nField: 'demoted', key: 'demoted', value: 'Demoted', text: 'Demoted'
  },
  {
    i18nField: 'fired', key: 'fired', value: 'Terminated/Fired/Dismissed/Discharged (military)', text: 'Terminated/Fired/Dismissed/Discharged (military)'
  },
  {
    i18nField: 'criminalAction', key: 'criminalAction', value: 'Criminal action', text: 'Criminal action'
  },
  {
    i18nField: 'ucmjAction', key: 'ucmjAction', value: 'UCMJ action', text: 'UCMJ action'
  },
  {
    i18nField: 'other', key: 'other', value: 'Other', text: 'Other'
  },
  {
    i18nField: 'none', key: 'none', value: 'None', text: 'None'
  },
]);

// PVQ Dropdown values
export const travelCardActionOptions = new EappEnum([
  {
    i18nField: 'paidAll', key: 'paidAll', value: 'I paid all unauthorized expenses.', text: 'I paid all unauthorized expenses.'
  },
  {
    i18nField: 'meetingTerms', key: 'meetingTerms', value: 'I am successfully meeting the terms of a payment plan.', text: 'I am successfully meeting the terms of a payment plan.'
  },
  {
    i18nField: 'wagesGarnished', key: 'wagesGarnished', value: 'I have my pay garnished.', text: 'I have my pay garnished.'
  },
  {
    i18nField: 'counsel', key: 'counsel', value: 'I\'m using a credit counseling service, debt consolidation service, or other similar service to resolve this financial obligation.', text: 'I\'m using a credit counseling service, debt consolidation service, or other similar service to resolve this financial obligation.'
  },
  {
    i18nField: 'completedTraining', key: 'completedTraining', value: 'I completed additional training or counseling.', text: 'I completed additional training or counseling.'
  },
  {
    i18nField: 'eap', key: 'eap', value: 'I\'m using my agency\'s or employer\'s Employee Assistance Program (EAP).', text: 'I\'m using my agency\'s or employer\'s Employee Assistance Program (EAP).'
  },
  {
    i18nField: 'other', key: 'other', value: 'Other', text: 'Other'
  },
  {
    i18nField: 'none', key: 'none', value: 'None', text: 'None'
  },
]);
